(() => {
  const formatMoney = (cents) => `$${(Number(cents) / 100).toFixed(2)}`;

  document.querySelectorAll("[data-bbgm-bundle-buybox]").forEach((buybox) => {
    const root = buybox.closest("[data-bbgm-product]");
    const config = root?.querySelector(".bbgm-shopify-config");
    const inputs = [...buybox.querySelectorAll('input[name="routine"]')];
    const subscriptionInput = buybox.querySelector('input[value="subscribe"]');
    const oneTimeInput = buybox.querySelector('input[value="once"]');
    const subscriptionPrice = Number(buybox.dataset.subscriptionPrice || 0);
    const oneTimePrice = Number(buybox.dataset.oneTimePrice || 0);
    const renewalPrice = Number(buybox.dataset.renewalPrice || subscriptionPrice);
    const cadenceDays = Number(buybox.dataset.cadenceDays || 30);
    const variantId = Number(buybox.dataset.variantId || config?.dataset.variantId || 0);
    const sellingPlanId = Number(buybox.dataset.subscriptionPlanId || 0);
    const approvedPlanId = Number(buybox.dataset.approvedPlanId || 0);
    const cta = buybox.querySelector("[data-routine-cta]");
    const purchaseNote = buybox.querySelector("[data-purchase-note]");
    const renewalDisclosure = buybox.querySelector("[data-renewal-disclosure]");
    const oneTimeDetails = buybox.querySelector(".bbgm-bundle-choice__benefits--once");
    const stickyButton = root?.querySelector("[data-sticky-routine]");
    const stickyPrice = root?.querySelector("#sticky-price");
    const stickyPlan = root?.querySelector("#sticky-plan");
    const status = root?.querySelector(".bbgm-cart-status");
    const planNode = config?.querySelector(`[data-selling-plan-option][data-plan-id="${sellingPlanId}"]`);
    const allocationPrice = Number(planNode?.dataset.planPrice || 0);
    const subscriptionConfigured = Boolean(
      variantId
      && approvedPlanId
      && sellingPlanId === approvedPlanId
      && planNode
      && allocationPrice === subscriptionPrice,
    );

    const selectedInput = () => inputs.find((input) => input.checked) || oneTimeInput;

    function syncPurchaseState() {
      const selected = selectedInput();
      const isSubscription = selected === subscriptionInput && subscriptionConfigured;
      const selectedPrice = isSubscription ? subscriptionPrice : oneTimePrice;

      buybox.querySelectorAll(".bbgm-bundle-choice").forEach((choice) => {
        choice.classList.toggle("is-selected", choice.contains(selected));
      });
      if (oneTimeDetails) oneTimeDetails.hidden = selected !== oneTimeInput;
      if (cta) cta.textContent = `${isSubscription ? "Start now" : "Add to cart"} · ${formatMoney(selectedPrice)}`;
      if (purchaseNote) {
        purchaseNote.textContent = isSubscription
          ? "◇ SUBSCRIPTION SAVINGS AUTO-APPLIED"
          : "◇ ONE-TIME PURCHASE · NO AUTO-RENEWAL";
      }
      if (renewalDisclosure) {
        renewalDisclosure.textContent = isSubscription
          ? (renewalPrice === subscriptionPrice
              ? `${formatMoney(subscriptionPrice)} every ${cadenceDays} days. Pause, skip, or cancel anytime.`
              : `First order ${formatMoney(subscriptionPrice)}. Renews at ${formatMoney(renewalPrice)} every ${cadenceDays} days. Pause, skip, or cancel anytime.`)
          : `One complete protocol delivered once. No subscription or automatic renewal.`;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(selectedPrice);
      if (stickyPlan) stickyPlan.textContent = isSubscription ? "Monthly Subscribe & Save" : "One-Time Purchase";
      if (stickyButton) stickyButton.textContent = isSubscription ? "START NOW" : "ADD TO CART";
    }

    if (!subscriptionConfigured && subscriptionInput && oneTimeInput) {
      subscriptionInput.disabled = true;
      subscriptionInput.closest(".bbgm-bundle-choice")?.setAttribute("aria-disabled", "true");
      subscriptionInput.checked = false;
      oneTimeInput.checked = true;
      if (status) status.textContent = "Subscription pricing is temporarily unavailable. One-time purchase is selected.";
    }

    inputs.forEach((input) => input.addEventListener("change", () => {
      queueMicrotask(syncPurchaseState);
    }));
    requestAnimationFrame(syncPurchaseState);

    const addToCart = async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!variantId) {
        if (status) status.textContent = "This product is temporarily unavailable.";
        return;
      }
      const wantsSubscription = selectedInput() === subscriptionInput && subscriptionConfigured;
      const item = wantsSubscription
        ? Object.freeze({ id: variantId, quantity: 1, selling_plan: sellingPlanId })
        : Object.freeze({ id: variantId, quantity: 1 });
      const buttons = [cta, stickyButton].filter(Boolean);
      buttons.forEach((button) => { button.disabled = true; });
      if (status) status.textContent = "Adding to cart…";

      try {
        const response = await fetch(config?.dataset.cartAddUrl || "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [item] }),
        });
        if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);
        const payload = await response.json();
        const addedItem = payload.items?.[0] || payload;
        const drawer = root?.querySelector(".cart-drawer");
        const cartPrice = root?.querySelector(".cart-price");
        const cartVariant = root?.querySelector(".cart-variant");
        const linePrice = Number(addedItem.final_line_price ?? addedItem.final_price ?? 0);
        root?.querySelector(".cart-button span")?.replaceChildren(document.createTextNode("1"));
        if (cartPrice) cartPrice.textContent = formatMoney(linePrice);
        if (cartVariant) {
          cartVariant.textContent = wantsSubscription
            ? `Monthly Subscribe & Save / Renews every ${cadenceDays} days`
            : "One-Time Purchase / Delivered once";
        }
        if (drawer) {
          const empty = drawer.querySelector(".cart-empty");
          const cartItem = drawer.querySelector(".cart-item");
          const checkout = drawer.querySelector(".checkout");
          if (empty) empty.hidden = true;
          if (cartItem) cartItem.hidden = false;
          if (checkout) {
            checkout.hidden = false;
            checkout.onclick = () => window.location.assign(config?.dataset.cartUrl || "/cart");
          }
        }
        try {
          const cartResponse = await fetch("/cart.js", { headers: { Accept: "application/json" } });
          if (cartResponse.ok) {
            const cartState = await cartResponse.json();
            root?.querySelector(".cart-button span")?.replaceChildren(
              document.createTextNode(String(cartState.item_count || 0)),
            );
          }
        } catch (error) {
          // The add succeeded; keep the local count if the secondary cart read is unavailable.
        }
        if (status) status.textContent = "Added to cart.";
        if (typeof window.bettrbioOpenCart === "function") window.bettrbioOpenCart();
      } catch (error) {
        if (status) status.textContent = "We couldn't add that to your cart. Please try again.";
      } finally {
        buttons.forEach((button) => { button.disabled = false; });
      }
    };

    [cta, stickyButton].filter(Boolean).forEach((button) => {
      button.addEventListener("click", addToCart, true);
    });
  });
})();
